export interface Content {
  id: string | number;
  name: string;
  description: string | any;
}
